import {useEffect, useState} from 'react';
import {INITIAL_PAGE, ITEMS_PER_PAGE} from '../../constants';

const useCategoryProducts = (category, setNumOfPages, currentPage, search) => {
    const [products, setProducts] = useState([]);
    const [hasMore, setHasMore] = useState();

    useEffect(() => {
        handleProductList(category);

        // return () => {
        //     setProducts([]);
        // };
    }, [category, currentPage, search]);

    const handleProductList = async category => {
        if (category) {
            try {
                const {paginatedProducts, totalCount} = await category.getActiveProducts(currentPage, ITEMS_PER_PAGE, search);
                setProducts(prev => [...prev, ...paginatedProducts]);
                setHasMore(totalCount > ITEMS_PER_PAGE);

                console.log('paginated Page', paginatedProducts);
            } catch (err) {
                console.log('err in handleProductList', err);
            }
        }
    };

    return {products, hasMore, setProducts};
};

export default useCategoryProducts;
